import React, { Component } from 'react';

const styles = {
    borderRadius: '4px',
}

class PanelFrame extends Component {
    render() {
        const { id, style, backgroundColor, onClick, children, className } = this.props
        return (
            <div id={id} className={className} style={{...style, ...styles, backgroundColor: backgroundColor}} onClick={onClick} >
                {children}
            </div>
        );
    }
}

export default PanelFrame;